import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";

const sections = [
  {
    title: "What these technologies are",
    body: [
      "Cookies are small files a website or service places in a browser. Local storage is a related browser feature that can save information on a device without sending it with every request. Pixels, tags and software-development tools can perform similar functions.",
    ],
  },
  {
    title: "Storage used by this storefront",
    body: [
      `This storefront uses local storage keys named ${siteConfig.storage.cartKey} and ${siteConfig.storage.wishlistKey} to remember product identifiers, selected options and quantities in the cart and favourites on the device. This information supports the shopping experience and is not a complete order record.`,
    ],
  },
  {
    title: "Strictly necessary technologies",
    body: [
      "Hosting, security and payment services may use short-lived or persistent technologies that are necessary to deliver pages, balance traffic, prevent abuse, maintain a checkout session or complete payment. Blocking them can prevent parts of the store or checkout from working.",
    ],
  },
  {
    title: "Optional analytics and advertising",
    body: [
      "This storefront does not currently describe or rely on an optional advertising-cookie programme. If optional analytics, personalisation or advertising technologies are introduced, this policy and any consent interface will be updated before they are used where consent is required.",
    ],
  },
  {
    title: "Third-party checkout",
    body: [
      "When you continue to the payment provider, its website may use its own cookies or similar technologies for security, fraud prevention and checkout. Its cookie and privacy notices govern that separate service.",
    ],
  },
  {
    title: "Managing storage",
    body: [
      "Browser settings can show, block or delete cookies and site data. Clearing local storage removes the saved cart and favourites from that browser. Blocking strictly necessary technologies may stop checkout or other requested features from functioning correctly.",
    ],
  },
  {
    title: "Do Not Track and preference signals",
    body: [
      "Browsers may send preference signals such as Do Not Track or a legally recognised opt-out signal. Because standards and legal effects vary, we respond where required and will describe any material change to our handling here.",
    ],
  },
  {
    title: "Questions and updates",
    body: [
      `We update this policy when the technologies or providers materially change. Questions about browser storage can be sent to ${siteConfig.contact.email}.`,
    ],
  },
];

export default function Cookies() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Cookie policy"
      intro={`How ${siteConfig.brandName} uses cookies, local storage and related technologies.`}
      sections={sections}
    />
  );
}

